import { useLocalStorage } from 'react-use';

import { LocalStorageKey } from 'src/core/constants/storage';

import { type EntityBasicInformation } from '../types';

export const usePinnedEntities = () => {
  const [pinnedEntitiesFromStorage, setPinnedEntitiesFromStorage] =
    useLocalStorage<string[]>(LocalStorageKey.MultiEntityHubPinnedEntities, []);
  const handleTogglePinnedEntity = (entityId: string) => {
    const currentPinnedEntities = pinnedEntitiesFromStorage ?? [];
    const newPinnedEntities = currentPinnedEntities.includes(entityId)
      ? currentPinnedEntities.filter((id) => id !== entityId)
      : [...currentPinnedEntities, entityId];
    setPinnedEntitiesFromStorage(newPinnedEntities);
  };

  const isPinned = (entity: EntityBasicInformation) =>
    pinnedEntitiesFromStorage?.includes(entity.id) ?? false;

  return {
    pinnedEntities: pinnedEntitiesFromStorage,
    handleTogglePinnedEntity,
    isPinned,
  };
};
